import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ConsentProgramHistory } from "@/Common/Models/Patient/ConsentProgramHistory";
import { PatientConsentPrograms } from "./PatientConsentPrograms";

interface IPatientConsentProgramHistoryProps {
    patientContactId: string;
    items: Immutable.List<ConsentProgramHistory>;
    onClose: () => void;
}

const PatientConsentProgramHistory: React.FC<IPatientConsentProgramHistoryProps> = ({ patientContactId, items, onClose }: IPatientConsentProgramHistoryProps) => {
    const { getText } = useTranslation();

    return (
        <Modal
            showOverlay
            showX
            width={1000}
            maxHeight="80vh"
            title={getText("Consent_ConsentProgramHistoryLabel")}
            onClose={onClose}
            disableOverlayClose
            centerContent
        >
            <PatientConsentPrograms
                patientContactId={patientContactId}
                items={items}
                readOnly
                isHistory
            />
        </Modal>
    );
};

export { PatientConsentProgramHistory };
